import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minLenght'
})
export class ErrorMessagesMinLenghtPipe implements PipeTransform {

  transform(value: string, size: number): string {
    return `${value} debe ser al menos ${size} caracteres`;
  }
}

@Pipe({
  name: 'maxLenght'
})
export class ErrorMessagesMaxLenghtPipe implements PipeTransform {

  transform(value: string, size: number): string {
    return `${value} excedió  el número máximo de caracteres permitidos`;
  }
}

@Pipe({
  name: 'min'
})
export class ErrorMessagesMinPipe implements PipeTransform {

  transform(value: string, min: number): string {
    return `${value} debe ser mínimo ${min}`;
  }
}

@Pipe({
  name: 'max'
})
export class ErrorMessagesMaxPipe implements PipeTransform {

  transform(value: string, max: number): string {
    return `${value} debe ser máximo ${max}`;
  }
}

@Pipe({
  name: 'required'
})
export class ErrorMessagesRequiredPipe implements PipeTransform {

  transform(value: string): string {
    return `${value} es requerido`;
  }
}

@Pipe({
  name: 'invalid'
})
export class ErrorMessagesInvalidPipe implements PipeTransform {

  transform(value: string): string {
    return `${value} es inválido`;
  }
}

@Pipe({
  name: 'duplicate'
})
export class ErrorMessagesDuplicatePipe implements PipeTransform {

  transform(value: string): string {
    return `${value} ya existe`;
  }
}
